<template>
  <v-card>
      <v-card-title>
        <div>
          <div class="headline">Travel Scheme Map</div>
        </div>
        <v-spacer></v-spacer>
        <v-flex xs6>
          <v-autocomplete :items="schemeList" v-model="filters.search" :label="filtersLabel.scheme" item-text="label" item-value="value" clearable></v-autocomplete>
        </v-flex>
      </v-card-title>
      <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="filters.search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="name" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
        <template slot="headerCell" slot-scope="props">
          <v-tooltip bottom>
            <span slot="activator">
              {{ props.header.text }}
            </span>
            <span>
              {{ props.header.text }}
            </span>
          </v-tooltip>
        </template>
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ props.item.schemeDesc }}</td>
          <td class="text-xs-left">{{ props.item.tripTypeDesc }}</td>
          <td class="text-xs-left">{{ props.item.travelTypeDesc }}</td>
          <td class="text-xs-right">
            <table-action :rowData="props" :remove="checkAccess(['travelRatingReview'])" @remove="doPromptRemove(props.item)"></table-action>
          </td>
        </template>
      </v-data-table>
      <v-btn color="primary" dark class="mb-2" @click.native="doNew()">New Scheme<v-icon>mdi-plus</v-icon></v-btn>
      <v-dialog v-model="schemeDialog" max-width="600px" persistent>
        <v-card>
          <v-card-title>
            <span class="headline">Permit Scheme for Product</span>
          </v-card-title>
          <v-card-text>
            <message :messages="messages"></message>
            <v-container grid-list-md>
              <v-layout row wrap>
                <v-flex xs12 class="ma-2">
                  <v-subheader class="queryLabel">{{labels.product}}</v-subheader>
                  <div class="title">{{schemeForm.product}}</div>
                </v-flex>
                <v-flex xs6>
                  <v-autocomplete :label="labels.tripType" v-model="schemeForm.tripType" :items="tripTypeList" item-text="label" item-value="value" :error-messages="errors.collect('tripType')" data-vv-name="tripType" :data-vv-as="labels.tripType" v-validate="'required'"></v-autocomplete>
                </v-flex>
                <v-flex xs6>
                  <v-autocomplete :label="labels.travelType" v-model="schemeForm.travelType" :items="travelTypeList" item-text="label" item-value="value" :error-messages="errors.collect('travelType')" data-vv-name="travelType" :data-vv-as="labels.travelType" v-validate="'required'"></v-autocomplete>
                </v-flex>
                <v-flex xs6>
                  <v-autocomplete :label="labels.scheme" v-model="schemeForm.scheme" :items="schemeList" item-text="label" item-value="value" :error-messages="errors.first('product') ? errors.first('product') :errors.collect('scheme')" data-vv-name="scheme" :data-vv-as="labels.scheme" v-validate="'required'" :loading="schemeLoading"></v-autocomplete>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" flat @click.native="doClose">Cancel</v-btn>
            <v-btn color="primary" flat @click.native="doSave">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <confirm v-model="promptRemove" @ok="doRemove">
      Are you sure that you want to delete the selected Permitted Scheme?
      <div class="title">{{deleteProductScheme}}</div>
      </confirm>
    </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { mapGetters } from 'vuex'
import { expandURI } from '@/utils/ajax'
import FieldMixin from '@/mixins/field'
import { tripType, travelType } from '@/const/underwriting/travel'
export default {
  data() {
    return {
      headers: [
        { text: 'Scheme', value: 'schemeDesc' },
        { text: 'Trip Type', value: 'tripTypeDesc' },
        { text: 'Travel Type', value: 'travelTypeDesc' },
        TableConst.tableActionHeader
      ],
      filtersLabel: {
        scheme: 'Scheme'
      },
      filters: {
        search: null
      },
      labels: {
        product: 'Product',
        schemeQuery: 'Scheme',
        tripType: 'Trip Type*',
        scheme: 'Scheme*',
        travelType: 'Travel Type*'
      },
      schemeForm: {
        product: null,
        scheme: null,
        tripType: null,
        travelType: null
      },
      loading: null,
      newProduct: false,
      schemeList: [],
      schemeDialog: false,
      schemeLoading: false,
      newSchemeProduct: false,
      menu: [],
      deleteProductScheme: '',
      promptRemove: false,
      travelTypeList: [],
      tripTypeList: []
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    productMenu() {
      return this.$store.state.productManagement.product.menu
    },
    appID() {
      return this.$store.state.parameters.appID
    }
  },
  methods: {
    async doInit() {
      if (this.$store.state.productManagement.product.init !== 1) {
        await this.$store.dispatch('productMenuInit', this.product)
      }
      if (!this.newProduct) {
        // Review
        await this.fetchData(this.product)
      }
      await this.schemeListInit()
    },
    async fetchData(xproduct) {
      Promise.all([this.doTravelTypeList(), this.doTripTypeList()])
      const apiURI = this.productMenu.schemeProducts
      let expand = {
        product: xproduct
      }
      if (apiURI) {
        const result = await this.$http.get(expandURI(apiURI, expand))
        if (result.data) {
          this.totalItems = result.data.totalElements
          const { data } = result.data
          if (data) {
            this.items = []
            this.productList = data.productList
            data.map((productScheme) => {
              const convertProductScheme = {
                product: productScheme.product,
                productDesc: productScheme.productDesc,
                scheme: productScheme.scheme,
                schemeDesc: productScheme.schemeDesc,
                travelType: productScheme.travelType,
                travelTypeDesc: productScheme.travelTypeDesc,
                tripType: productScheme.tripType,
                tripTypeDesc: productScheme.tripTypeDesc
              }
              this.items.push(convertProductScheme)
            })
            this.loading = false
          } else {
            this.items = []
          }
        }
      }
    },
    doClearFilters() {
      this.filters.scheme = null
      this.fetchData(this.product)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          // Reset to page 1
          this.pagination.page = 1
          this.fetchData(this.product)
        }
      })
    },
    doNew() {
      this.resetMessages()
      this.schemeForm.product = this.product
      this.schemeForm.scheme = null
      this.schemeForm.tripType = null
      this.schemeForm.travelType = null
      this.schemeDialog = true
      this.newSchemeProduct = true
    },
    async schemeListInit() {
      const apiURI = this.productMenu.schemeList
      if (apiURI) {
        try {
          const expand = {
            appId: this.appID
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.schemeList = data
          }
        } catch (error) {
          const { data } = error.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.$snotify.error('Invalid API URL - Product Scheme List')
      }
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.doCreate()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.productMenu.schemeProductCreate
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.schemeForm)
          const { data } = result

          if (data) {
            // Show message via notify
            this.notify(data)
            await this.fetchData(this.schemeForm.product)
            this.doClose()
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.$snotify.error('Invalid API URL - Product Scheme Create')
      }
    },
    doClose() {
      this.resetMessages()
      this.schemeForm.scheme = undefined
      this.schemeForm.tripType = null
      this.schemeForm.travelType = null
      this.schemeDialog = false
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedProductScheme = data
        this.deleteProductScheme = data.schemeDesc
      }
    },
    async doRemove() {
      const apiURI = this.$store.state.productManagement.product.menu.schemeProductDelete
      if (apiURI) {
        this.loading = true
        const expand = {
          scheme: this.selectedProductScheme.scheme,
          product: this.product,
          travelType: this.selectedProductScheme.travelType,
          tripType: this.selectedProductScheme.tripType
        }
        try {
          const result = await this.$http.post(apiURI, expand)
          this.notify(result.data)
          // Reinit
          this.doInit()
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.$snotify.error('Invalid API URL - Delete Product Scheme')
      }
    },
    doTripTypeList() {
      this.tripTypeList = []
      const list = Object.freeze(tripType)
      let convertArray = Object.keys(list).map(key => {
        return {
          label: key + ' - ' + list[key],
          value: key
        }
      })
      this.tripTypeList = convertArray
    },
    doTravelTypeList() {
      this.travelTypeList = []
      const list = Object.freeze(travelType)
      let convertArray = Object.keys(list).map(key => {
        return {
          label: key + ' - ' + list[key],
          value: key
        }
      })
      this.travelTypeList = convertArray
    }
  },
  mounted() {
    if (this.product === 'new') {
      this.newProduct = true
    } else {
      this.doInit()
    }
  },
  props: {
    product: {
      type: String,
      default: ''
    }
  },
  mixins: [
    TableConst.default,
    MessageMixin,
    FieldMixin
  ]
}
</script>

<style>

</style>
